module.exports = __webpack_public_path__ + "img/13@3x.d3c9d343.png";